<template>
   <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3ZM17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12V15H12C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17H15V20C15 20.5523 15.4477 21 16 21C16.5523 21 17 20.5523 17 20V17H20C20.5523 17 21 16.5523 21 16C21 15.4477 20.5523 15 20 15H17V12Z" fill="#415A77"/>
</svg>


</template>